module.exports = require("@collectivehealth/dls-panel");